var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"breadcrumb-nav column is-offset-1"},_vm._l((_vm.crumbs),function(c){return _c('p',{key:c.text},[(c.l)?_c('router-link',{attrs:{"to":c.l}},[_vm._v(_vm._s(c.text)+" ")]):_c('span',[_vm._v(" "+_vm._s(c.text)+" ")])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40b472a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumb.vue
// module id = null
// module chunks = 